/**
 * @generated SignedSource<<5122ea0c11c0e5b188047a757a26d62c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreateReactionInput = {
  messageId: string;
  reaction: any;
};
export type AnnouncementReactionButton_chat_createReaction_Mutation$variables = {
  input: CreateReactionInput;
};
export type AnnouncementReactionButton_chat_createReaction_Mutation$data = {
  readonly createReaction: {
    readonly id: string;
    readonly message: {
      readonly " $fragmentSpreads": FragmentRefs<"AnnouncementReactionButton_chat_messageFragment">;
    } | null;
  };
};
export type AnnouncementReactionButton_chat_createReaction_Mutation = {
  response: AnnouncementReactionButton_chat_createReaction_Mutation$data;
  variables: AnnouncementReactionButton_chat_createReaction_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AnnouncementReactionButton_chat_createReaction_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Message",
        "kind": "LinkedField",
        "name": "createReaction",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Message",
            "kind": "LinkedField",
            "name": "message",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AnnouncementReactionButton_chat_messageFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AnnouncementReactionButton_chat_createReaction_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Message",
        "kind": "LinkedField",
        "name": "createReaction",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Message",
            "kind": "LinkedField",
            "name": "message",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ReactionsConnection",
                "kind": "LinkedField",
                "name": "reactions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ReactionsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Message",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "text",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "senderId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "deletedAt",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "815d3aed85db4860494e084cd7137999",
    "id": null,
    "metadata": {},
    "name": "AnnouncementReactionButton_chat_createReaction_Mutation",
    "operationKind": "mutation",
    "text": "mutation AnnouncementReactionButton_chat_createReaction_Mutation(\n  $input: CreateReactionInput!\n) {\n  createReaction(input: $input) {\n    id\n    message {\n      ...AnnouncementReactionButton_chat_messageFragment\n      id\n    }\n  }\n}\n\nfragment AnnouncementReactionButton_chat_messageFragment on Message {\n  id\n  reactions {\n    edges {\n      node {\n        id\n        text\n        senderId\n        deletedAt\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7ad27c40efd2fcdb000c1c32f9ffbb4d";

export default node;
